import { render, staticRenderFns } from "./TableIndexPresenter.vue?vue&type=template&id=fdde22fc&"
import script from "./TableIndexPresenter.vue?vue&type=script&lang=ts&"
export * from "./TableIndexPresenter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports